export default class CommonHelp {
  static getPage(list=[],page=1,pageSize=15){
    return list.slice((page-1)*pageSize,page*pageSize);
  }
}



// WEBPACK FOOTER //
// ./src/components/Admin/MeterVirtually/components/virtually/components/common/CommonHelp.js